import VueI18n from "vue-i18n";
import Vue from "vue";
import en from "./translations/en";
import de from "./translations/de";
import zh from "./translations/zh";

const messages = {
  en: en.en,
  de: de.de,
  zh: zh.zh
};

Vue.use(VueI18n);

let lang = localStorage.getItem("lang");
if (!lang) {
  // @ts-ignore
  lang = navigator.locale !== "zh" ? "en" : "zh";
}
export const i18n = new VueI18n({
  locale: lang,
  messages
});
